<template>
  <section class="module max-width slideshow-module">
		<div class="module-wrapper">
      <div class="slideshow" :class="{visible: isVisible}" ref="gallery" @mouseenter="pauseAutoplay" @mouseleave="autoplay">
        <article class="slide" v-for="slide in slides" :key="slide.id" :style="{backgroundColor: slide.color}">
          <div class="skewed">
            <div class="box skew">
              <div class="front">
                <img v-if="slide.album.cover.path" :src="slide.album.cover.path" />
                <img v-else src="/themes/caramba/assets/images/album.jpg" />
              </div>
              <div class="back"></div>
              <div class="left"></div>
              <div class="right"></div>
              <div class="top"></div>
              <div class="bottom"></div>
            </div>
          </div>
          
          <div class="text">
            <h2 class="xxl regular">{{ slide.album.artist.name }}</h2>
            <h3 class="xxl light">{{ slide.album.title }}</h3>
            <router-link :to="'/catalog/' + slide.album.slug" class="button button-regular button-yellow button-anim">Vedi l'intero disco</router-link>
          </div>
        </article>
      </div>

      <a href="#0" @click.prevent="setIndex('prev')" class="nav-prev"><svg class="prev-link post-link" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="22.917px" height="44.083px" viewBox="0 0 22.917 44.083" enable-background="new 0 0 22.917 44.083" xml:space="preserve"><polyline fill="none" stroke="#333333" stroke-width="2" stroke-miterlimit="10" points="22.047,43.5 0.833,22 22.047,0.787"></polyline></svg></a>
      <a href="#0" @click.prevent="setIndex('next')" class="nav-next"><svg class="next-link post-link" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="22.917px" height="44.083px" viewBox="0 0 22.917 44.083" enable-background="new 0 0 22.917 44.083" xml:space="preserve"><polyline fill="none" stroke-width="2" stroke="#333333" stroke-miterlimit="10" points="0.5,0.787 21.713,22.287 0.5,43.5"></polyline></svg></a>
    </div>
	</section>
</template>

<script>
import axios from 'axios/dist/axios';
import Siema from 'siema';

export default {
  name: 'Slideshow',
  
  data () {
    return {
      slides: [],
      isVisible: false,
      siema: undefined,
      autoplayInterval: undefined
    }
  },

  mounted: function() {    
  	axios.get(window.location.origin + '/api/v1/carousel/list')
      .then(resp => {
        this.slides = resp.data;
        setTimeout(() => this.start(), 10);
      });
  },

  beforeDestroy: function() {
    if(this.siema) this.siema.destroy();
  },
  
  methods: {
    start: function() {
      const that = this;

      this.siema = new Siema({
        selector: this.$refs.gallery,
        duration: 300,
        easing: 'ease-in-out',
        perPage: 1,
        loop: true,
        onInit: function() { that.isVisible = true; that.autoplay(); },
        onChange: function() {}
      });
    },

    autoplay: function() {
      if(!this.autoplayInterval) {
        this.autoplayInterval = setInterval(() => this.siema.next(), 3000);
      }
    },

    pauseAutoplay: function() {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = undefined;
    },

    setIndex: function(dir) {
      if(this.siema) {
        this.siema[dir]();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.slideshow {
  opacity: 0;
  transition: 0.7s all;
}

.slideshow.visible {
  opacity: 1;
}

.slide {
  display: block;
  height: 100%;
  overflow: hidden;
  position: relative;
}

.module-wrapper {
  position: relative;
}

.nav-prev,
.nav-next {
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  transition: 0.3s all;
  height: auto !important;
  padding: 20px;
}

.nav-prev {
  left: 72px;

  &:hover {
    transform: translate(-10px, -50%);
  }
}

.nav-next {
  right: 72px;

  &:hover {
    transform: translate(10px, -50%);
  }
}

@media (max-width: 1024px) {
  .nav-prev,
  .nav-next {
    top: auto;
    transform: none;
    bottom: 0;
  }

  .nav-prev {
    left: 0;
    
    &:hover {
      transform: translate(-10px, 0);
    }
  }

  .nav-next {
    right: 0;

    &:hover {
      transform: translate(10px, 0);
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/vue/components/Slideshow.vue